import React, {
  useEffect,
  useState,
  useContext,
  useLayoutEffect,
  useRef,
  useCallback,
} from "react";
import axios from "axios";
import { getSymbols } from "../utils/api";
import { useLtpContext } from "../context/LtpContext";
import { useBasketContext } from "../context/BasketContext";

import ABWebSocketContext from "../context/ABWebsocketContext";
import CustomToastContent from "./CustomToastContent";
import { toast } from "react-toastify";
import SuccessIcon from "../images/success_icon.svg";
import WebsocketWrapperContext from "../context/WebsocketWrapperContext";
import { useTheme } from "../context/ThemeContext";

import { ButtonContext } from "../context/ButtonsContext";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorIcon from "../images/error_icon.svg";

import { update } from "@react-spring/web";
import { useDataContext } from "../context/DataContext";

import { useBuySellModalContext } from "../context/BuySellModalContext";
import { convert_position } from "fyers-api-v2";
import { e, round } from "mathjs";
import BuySellModal from "../modals/BuySellModal";
import MarketDepthModal from "../modals/MarketDepthModal";
import ChartIcon from "../images/icons/barchart-default.svg";
import MarketDepthIcon from "../images/depth.svg";
import MarketDepthIconDark from "../images/depth_dark.svg";
import { getCookie } from "../utils/cookieUtils";
import AddToWatchlistModal from "./watchlist/components/AddToWatchlistModal";
import { getOIAnalysis } from "../utils/oiAnalysis";

// eslint-disable-next-line import/no-webpack-loader-syntax
// import GreeksWorker from 'worker-loader!../workers/greeksWorker.js';

const OptionChainTable = ({
  handleLotxChange,
  parentCallback2,
  optionData,
  showCalls,
  showPuts,
  symbol,
  calls,
  puts,
  clickEnable,
  showDelta,
  showTheta,
  showGamma,
  showVega,
  showRho,
  showOIChng,
  showOIBuilddup,
  isScalpOrderChecked,
  scalpLots,
  maxPain,
  selectedDate,
  setObjectData,
  objectData,
  selectedData,
  isFromCharts,
  isExpanded,
  directAddToBasket,
}) => {
  const { basketData, setBasketData, removeFromBasket, addToBasket } =
    useBasketContext();
  const { callsDataCon, setCallsDataCon, putsDataCon, setPutsDataCon } =
    useDataContext();
  const { buySellModalData, addToBuySellModal, setBuySellModalData } =
    useBuySellModalContext();
  const { theme } = useTheme();
  const [callsData, setCallsData] = useState([]);
  const { symbolData } = useContext(WebsocketWrapperContext);
  const [callBtnColor, setCallBtnColor] = useState(false);
  const [displayCalls, setDisplayCalls] = useState(showCalls);
  const [displayPuts, setDisplayPuts] = useState(showPuts);
  const [isRowHovered, setIsRowHovered] = useState(false);
  const [atmIndex, setAtmindex] = useState(0);
  const [ltp, setLtp] = useState(0);
  const [selectedSymbol, setSelectedSymbol] = useState(null);
  const [btnColor, setBtnColor] = useState({});
  // const [selectedDate, setSelectedDate] = useState("");
  const [activeDate, setActiveDate] = useState("");
  const [reducedData, setReducedData] = useState();

  const { isLive, isVirtual } = useContext(ButtonContext);
  const broker = localStorage.getItem("broker");
  const access_token = getCookie("access_token");
  const client_id = getCookie("client_id");
  const ltpValue = symbolData[symbol?.code]?.ltp || 0;
  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle chart navigation
  const handleChartNavigation = (symbolCode) => {
    if (location.pathname === "/charts") {
      // If already on charts page, navigate with the symbol code
      navigate(`/charts?code=${symbolCode}`);
    } else {
      // If not on charts page, navigate to charts with the symbol code
      navigate(`/charts?code=${symbolCode}`);
    }
  };

  const [value, setValue] = useState(1);
  const [maxVolume, setMaxVolume] = useState(0);
  const [maxPutVolume, setMaxPutVolume] = useState(0);
  const [activeButtonIndex, setActiveButtonIndex] = useState(null);
  const [activeButtonSellIndex, setActiveButtonSellIndex] = useState(null);
  const [sellbtnState, setSellbtnState] = useState(false);
  const [alreadyScrolled, setAlreadyScrolled] = useState(false);
  const [hasInitialScrolled, setHasInitialScrolled] = useState(false);
  const [userHasScrolled, setUserHasScrolled] = useState(false);
  const [inc, setInc] = useState(1);
  const [dec, setDec] = useState(inc);
  const targetRowRef = useRef(null);
  const isProgrammaticScroll = useRef(false);

  const workerRef = useRef();

  var iv = require("implied-volatility");
  var jStat = require("jstat");
  var greeks = require("greeks");
  // Update the state variables when props change
  useEffect(() => {
    setDisplayCalls(showCalls);
    setDisplayPuts(showPuts);
  }, [showCalls, showPuts]);

  const getRowColor = (strike, isCall) => {
    if (theme === "light") {
      const strikeCondition = isCall
        ? parseFloat(strike) < parseFloat(ltpValue)
        : parseFloat(strike) > parseFloat(ltpValue);
      if (strikeCondition) {
        return "#FFF9E5"; // Light yellow for ITM options
      } else {
        return "white";
      }
    } else {
      // Dark mode
      const strikeCondition = isCall
        ? parseFloat(strike) < parseFloat(ltpValue)
        : parseFloat(strike) > parseFloat(ltpValue);
      if (strikeCondition) {
        return isCall ? "#29292E" : "#FFF9E5";
      } else {
        return "transparent";
      }
    }
  };

  const handleAddModal = (data, index, isBuy, isCall) => {
    const ltpPrice = symbolData[data?.code]?.ltp;
    const data_object = {
      side: isBuy ? "Buy" : "Sell",
      instrumentName: data.instrument_name,
      lotSize: data.lot_size / data.lot_size,
      lot_size: data.lot_size,
      productType: "Normal",
      tradingSymbol: data.trading_symbol,
      expiryDate: data.expiry_date,
      code: data.code,
      price: ltpPrice || 0,
      trigger_price: ltpPrice || 0,
      buy_sell: isBuy ? "B" : "S",
      underlying_code: data.underlying_code,
      strike: data.strike,
      quantity: data.lot_size,
      exchange: data.exchange,
      scrip: data.underlying_symbol,
      lot_multiplier: data.lot_size,
      isCall: isCall,
      // trigger_price: sortedTradeData.ltp,
    };

    setBuySellModalData([data_object]);
    setModalAction("add");
    setModalOpen(true);
  };

  const handleAddToBasket = () => {
    handleLotxChange(1, true);

    const side = buySellModalData[0]?.isCall ? "Call" : "Put";
    const instrumentName = buySellModalData[0]?.instrumentName;
    const price = buySellModalData[0]?.price;
    const lotSize = buySellModalData[0]?.lotSize;
    const optionType = side === "Call" ? "CE" : "PE";
    const tradingSymbol = buySellModalData[0]?.tradingSymbol;
    const expiryDate = buySellModalData[0]?.expiryDate;
    const code = buySellModalData[0]?.code;

    const buy_sell = buySellModalData[0]?.buy_sell;
    const underlying_code = buySellModalData[0]?.code;
    const quantity = buySellModalData[0]?.quantity;

    const strike = buySellModalData[0]?.strike;

    let freeze_qty = null;
    let exchange = buySellModalData[0]?.exchange;
    let lot_multiplier = buySellModalData[0]?.lot_multiplier;
    let orderType = buySellModalData[0]?.orderType == "LIMIT" ? "L" : "M";
    const dataObject = {
      side,
      instrumentName,
      lotSize,
      optionType,
      tradingSymbol,
      expiryDate,
      code,
      price,
      buy_sell,
      underlying_code,
      strike,
      quantity,
      freeze_qty,
      exchange,
      lot_multiplier,
      scrip: selectedSymbol.scrip,
      orderType: orderType,
    };
    parentCallback2([dataObject, buySellModalData[0]?.buy_sell]);
  };

  const handleDirectAddToBasket = (data, isBuy, isCall) => {
    const ltpPrice = symbolData[data?.code]?.ltp;
    const side = isCall ? "Call" : "Put";
    const optionType = isCall ? "CE" : "PE";
    const buy_sell = isBuy ? "B" : "S";
    const dataObject = {
      side,
      instrumentName: data.instrument_name,
      lotSize: 1,
      optionType,
      tradingSymbol: data.trading_symbol,
      expiryDate: data.expiry_date,
      code: data.code,
      price: ltpPrice || 0,
      buy_sell,
      underlying_code: data.code,
      strike: data.strike,
      quantity: data.lot_size,
      freeze_qty: null,
      exchange: data.exchange,
      lot_multiplier: data.lot_size,
      scrip: selectedSymbol.scrip,
      orderType: "M",
    };
    parentCallback2([dataObject, buy_sell]);
    toast.success(
      <CustomToastContent
        heading="Added to Basket"
        message={`${data.instrument_name} (${isBuy ? "Buy" : "Sell"}) added to basket`}
      />,
      {
        className: "custom-success-toast",
        icon: <img src={SuccessIcon} alt="Success Icon" />,
      }
    );
  };

  // Function to generate order payload
  const generateOrderPayload = (basketData) => {
    const orderList = basketData.map((currData, ind) => ({
      isBuy: currData.buy_sell === "B" ? true : false,
      isCall: currData.side === "Call" ? true : false,
      isFut: false,
      code: currData.code,
      exchange: currData.exchange,
      // productType: activeOptions[ind] === "normal" ? "NRML" : "MIS",
      productType: "NRML",
      orderType: "MARKET",
      quantity: currData.lotSize * currData.lot_multiplier,
      price: currData.price,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiryDate,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      expiry: currData.expiryDate,
    }));
    return {
      order_list: orderList,
      broker: broker,
      access_token: access_token,
      client_id: client_id,
    };
  };

  const generateVirtualOrderPayload = (basketData) => {
    const orderList = basketData.map((currData, ind) => ({
      isBuy: currData.buy_sell === "B" ? true : false,
      isCall: currData.side === "Call" ? true : false,
      isFut: false,
      code: currData.code,
      exchange: currData.exchange,
      // productType: activeOptions[ind] === "normal" ? "NRML" : "MIS",
      productType: "NRML",
      orderType: "MARKET",
      quantity: currData.lotSize * currData.lot_multiplier,
      price: currData.price,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiry,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      expiry: currData.expiryDate,
    }));
    return {
      order_list: orderList,
      broker: "virtual",
      main_broker: broker,
      access_token: access_token,
      client_id: client_id,
    };
  };

  const handleToastToNavigate = (response) => {
    navigate(response.page);
  };

  const sendVirtualOrder = async (payload) => {
    try {
      const response = await axios.post(
        "https://hgb1gw5n6g.execute-api.ap-south-1.amazonaws.com/default/og_virtual_placeorder",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error placing order:", error);
      return {
        status: false,
        message_header: "Error placing order",
        message_body: error.message,
      };
    }
  };

  const sendOrder = async (payload) => {
    try {
      const response = await axios.post(
        "https://0eo1dv23p5.execute-api.ap-south-1.amazonaws.com/default/og_allbrokers_placeorder",
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error placing order:", error);
      return {
        status: false,
        message_header: "Error placing order",
        message_body: error.message,
      };
    }
  };

  const handleBuybtnState = () => {
    setCallBtnColor((prevState) => !prevState);
  };
  //Function  to handle lots size by typing
  const handleLotSizeChange = (newValue, index, side) => {
    const newLotsSize = parseInt(newValue); // Convert the new value to an integer

    if (basketData.length > 0) {
      const checkTradingSymbol =
        side === "calls"
          ? callsDataCon[index].trading_symbol
          : putsDataCon[index].trading_symbol;

      const positionIndex = basketData.findIndex(
        (position) => position.tradingSymbol === checkTradingSymbol
      );

      if (positionIndex !== -1) {
        // Position found in basketData
        const updatedBasketData = [...basketData];
        updatedBasketData[positionIndex].lotSize = newLotsSize;
        setBasketData(updatedBasketData);
      }
    } else {
      // Basket is empty, update options data
      if (side === "calls") {
        const updatedCallsDataCon = [...callsDataCon];
        updatedCallsDataCon[index].LotsSize = newLotsSize;
        setCallsDataCon(updatedCallsDataCon);
      } else {
        const updatedPutsDataCon = [...putsDataCon];
        updatedPutsDataCon[index].LotsSize = newLotsSize;
        setPutsDataCon(updatedPutsDataCon);
      }
    }
  };

  //function to handle lots size by clicking on increment
  const incrementValue = (index, side) => {
    if (
      basketData.length > 0 &&
      basketData.some(
        (position) =>
          position.tradingSymbol ===
          (side === "calls"
            ? callsDataCon[index].trading_symbol
            : putsDataCon[index].trading_symbol)
      )
    ) {
      const checkTradingSymbol =
        side === "calls"
          ? callsDataCon[index].trading_symbol
          : putsDataCon[index].trading_symbol;
      for (let i = 0; i < basketData.length; i++) {
        if (basketData[i].tradingSymbol === checkTradingSymbol) {
          let dataObject = basketData[i];
          dataObject["lotSize"] = dataObject["lotSize"] + 1;

          setBasketData((prevData) => [...prevData]);
        }
      }
    } else {
      if (side === "calls") {
        const updatedCallsDataCon = [...callsDataCon];
        updatedCallsDataCon[index].LotsSize += 1;
        setCallsDataCon(updatedCallsDataCon);
      } else {
        const updatedPutsDataCon = [...putsDataCon];
        updatedPutsDataCon[index].LotsSize += 1;
        setPutsDataCon(updatedPutsDataCon);
      }
    }
  };

  //function to handle lots size by clicking on decrement
  const decrementValue = (index, side) => {
    if (
      basketData.length > 0 &&
      basketData.some(
        (position) =>
          position.tradingSymbol ===
          (side === "calls"
            ? callsDataCon[index].trading_symbol
            : putsDataCon[index].trading_symbol)
      )
    ) {
      const checkTradingSymbol =
        side === "calls"
          ? callsDataCon[index].trading_symbol
          : putsDataCon[index].trading_symbol;
      for (let i = 0; i < basketData.length; i++) {
        if (
          basketData[i].tradingSymbol === checkTradingSymbol &&
          basketData[i].lotSize > 1
        ) {
          let dataObject = basketData[i];
          dataObject["lotSize"] = dataObject["lotSize"] - 1;
          setBasketData((prevData) => [...prevData]);
        }
      }
    } else {
      if (side === "calls") {
        if (callsDataCon[index].LotsSize > 1) {
          const updatedCallsDataCon = [...callsDataCon];
          updatedCallsDataCon[index].LotsSize -= 1;
          setCallsDataCon(updatedCallsDataCon);
        }
      } else {
        if (putsDataCon[index].LotsSize > 1) {
          const updatedPutsDataCon = [...putsDataCon];
          updatedPutsDataCon[index].LotsSize -= 1;
          setPutsDataCon(updatedPutsDataCon);
        }
      }
    }
  };

  const returnAtmIndex = () => {
    let index = 0;
    // Use effectiveLtp from optionData if available (for fallback scenarios), otherwise use WebSocket LTP
    const ltp = optionData?.effectiveLtp || symbolData[symbol?.code]?.ltp || 0;
    if (calls) {
      let curr = calls[0]?.strike,
        diff = Math.abs(ltp - curr);
      for (let val = 0; val < calls.length; val++) {
        let newdiff = Math.abs(ltp - calls[val].strike);
        if (newdiff < diff) {
          diff = newdiff;
          curr = calls[val];
          index = val;
        }
      }
    }
    setAtmindex(index);
  };
  useEffect(() => {
    returnAtmIndex();
  }, [calls, symbol, optionData]);

  // useLayoutEffect(() => {
  //   // console.log(targetRowRef.current);

  //   if (targetRowRef.current && !alreadyScrolled) {
  //     setTimeout(() => {
  //       targetRowRef.current.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });
  //       setAlreadyScrolled(true);
  //     }, 500);
  //   }
  // }, [atmIndex, targetRowRef.current]);

  const getPutRowColor = (strike) => {
    if (theme === "light") {
      if (parseFloat(strike) > parseFloat(ltpValue)) {
        return "#FFF9E5";
      } else {
        return "white";
      }
    } else {
      if (parseFloat(strike) > parseFloat(ltpValue)) {
        return "#29292E";
      } else {
        return "transparent";
      }
    }
  };
  // // console.log("this is call",symbolData[calls[1]?.code]?.oi/symbolData[calls[1]?.code]?.lot_size)
  //useEffect for calculating maximum OI
  useEffect(() => {
    const updateMaxVolume = () => {
      let newMaxVolume = 0;
      calls?.forEach((call, index) => {
        const temp = parseFloat(symbolData[call.code]?.oi);
        if (temp > newMaxVolume) {
          newMaxVolume = temp;
        }
      });
      setMaxVolume(newMaxVolume);
    };

    const updateMaxPutVolume = () => {
      let newMaxPutVolume = 0;
      puts?.forEach((put, index) => {
        const temp = parseFloat(symbolData[put.code]?.oi);
        // // console.log(temp);
        if (temp > newMaxPutVolume) {
          newMaxPutVolume = temp;
        }
      });
      // // console.log(newMaxPutVolume);
      setMaxPutVolume(newMaxPutVolume);
    };

    updateMaxVolume();
    updateMaxPutVolume();
  }, [calls, puts, symbolData, selectedDate, selectedSymbol]);

  // copying of data to callsdatacon and putsdatacon
  useEffect(() => {
    if (calls && calls.length > 0) {
      let callsTempData = calls.map((call) =>
        call
          ? { ...call, buyBtnState: false, sellBtnState: false, LotsSize: 1 }
          : null
      );
      setCallsDataCon(callsTempData.filter(Boolean));
    }
  }, [calls, selectedDate]);

  useEffect(() => {
    if (puts && puts.length > 0) {
      let putsTempData = puts.map((put) =>
        put
          ? { ...put, buyBtnState: false, sellBtnState: false, LotsSize: 1 }
          : null
      );
      setPutsDataCon(putsTempData.filter(Boolean));
    }
  }, [puts, selectedDate]);

  // updateMaxVolume();
  // updateMaxPutVolume();

  //taking from modal table
  useEffect(() => {
    const storedSymbol = sessionStorage.getItem("selectedSymbol");
    if (storedSymbol) {
      setSelectedSymbol(JSON.parse(storedSymbol));
    } else {
      const fetchSymbols = async () => {
        const symbols = await getSymbols();
        if (symbols) {
          const niftySymbol = symbols.find(
            (symbol) => symbol.scrip === "NIFTY"
          );
          setSelectedSymbol(niftySymbol);
          sessionStorage.setItem("selectedSymbol", JSON.stringify(niftySymbol));
        }
      };

      fetchSymbols();
    }
  }, [symbol]);

  // const fetchDataForSymbol = async (symbol, date) => {
  //   let brokerName = localStorage.getItem("broker_name");

  //   if (!brokerName) {
  //     console.error("Broker name not found in local storage.");
  //     return;
  //   }

  //   brokerName = brokerName.toLowerCase().replace(/\s+/g, "");
  //   // // console.log("Broker name from localstorage:", brokerName);
  //   const apiEndpoint = `https://y18wfq6w5b.execute-api.ap-south-1.amazonaws.com/default/og_expirysymbols?id=${symbol}${date}&broker=${brokerName}`;
  //   try {
  //     const response = await axios.get(apiEndpoint);
  //     const data = response.data;

  //     setReducedData(f);
  //     // console.log("Received data is: ", data);
  //   } catch (error) {
  //     console.error("Error: ", error);
  //   }
  // };

  function updateDivVisibility(callsDataCon, putsDataCon) {
    for (let i = 0; i < callsDataCon.length; i++) {
      if (
        callsDataCon[i] &&
        (callsDataCon[i].buyBtnState || callsDataCon[i].sellbtnState)
      ) {
        setDivVisibility(true);
        setSelectedRowIndex(i);
        return;
      }
    }

    for (let i = 0; i < putsDataCon.length; i++) {
      if (
        putsDataCon[i] &&
        (putsDataCon[i].buyBtnState || putsDataCon[i].sellbtnState)
      ) {
        setDivVisibility(true);
        setSelectedRowIndex(i);
        return;
      }
    }
  }

  useEffect(() => {
    if (selectedSymbol && selectedDate) {
      const f = getReducedData();
      setReducedData(f);
    }
  }, [selectedSymbol, selectedDate]);

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedSide, setSelectedSide] = useState(null);

  const getReducedData = () => {
    const sample = optionData && optionData.options && optionData.options;
    if (sample) {
      let f = sample.reduce((groupedOptions, option) => {
        const strike = option.call.strike;

        if (!groupedOptions[strike]) {
          groupedOptions[strike] = {
            call: option.call,
            put: option.put || {}, // Handle missing put data
          };
        } else {
          groupedOptions[strike].call = {
            ...groupedOptions[strike].call,
            ...option.call,
          };
          groupedOptions[strike].put = {
            ...groupedOptions[strike].put,
            ...option.put,
          };
        }
        return groupedOptions;
      }, {});

      return f;
    }
  };
  const [divVisibility, setDivVisibility] = useState(false);

  // const handleRowClick = (event, rowIndex, side) => {
  //   if (clickEnable) {
  //     const rowRect = event.currentTarget.getBoundingClientRect();
  //     const top = rowRect.top + window.scrollY;
  //     const left = rowRect.left + window.scrollX;
  //     setSelectedSide(side);
  //     setSelectedRowIndex(rowIndex);
  //   }
  // };

  const containerRef = useRef(null);
  const selectedRowIndexRef = useRef(null);
  const selectedSideRef = useRef(null);

  const handleRowMouseEnter = (index) => {
    setDivVisibility(true);
    setSelectedRowIndex(index);
  };

  const handleRowMouseLeave = () => {
    setDivVisibility(false);
    setSelectedRowIndex(null);
  };

  // const handleButtonClick = (event) => {
  //   const target = event.target;
  //   const isBuyButton = target.classList.contains("buy-btn");
  //   const isSellButton = target.classList.contains("sell-btn");
  //   const isBuySellButton = target.classList.contains(
  //     "open-buy-sell-modal-btn"
  //   );

  //   if (isBuyButton) {
  //     setSelectedRowIndex(selectedRowIndexRef.current);
  //     setSelectedSide(selectedSideRef.current);
  //     handleBuyClick();
  //   } else if (isSellButton) {
  //     setSelectedRowIndex(selectedRowIndexRef.current);
  //     setSelectedSide(selectedSideRef.current);
  //     handleSellClick();
  //   } else if (isBuySellButton) {
  //     setSelectedRowIndex(selectedRowIndexRef.current);
  //     setSelectedSide(selectedSideRef.current);
  //     handleBuySellModalClick();
  //   }
  // };

  //This block of container is used because in a way we have two onclick elements at a single place
  // useEffect(() => {
  //   const container = containerRef.current;
  //   if (container) {
  //     container.addEventListener("click", handleButtonClick);
  //   }

  //   return () => {
  //     if (container) {
  //       container.removeEventListener("click", handleButtonClick);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    selectedRowIndexRef.current = selectedRowIndex;
    selectedSideRef.current = selectedSide;
  }, [selectedRowIndex, selectedSide]);

  let uniqueStrikes = Array.from(
    new Set(
      optionData?.options
        ? optionData.options.map((option) => option.call.strike)
        : null
    )
  );

  uniqueStrikes.sort((a, b) => a - b);
  if (uniqueStrikes.length == 0) {
    setTimeout(() => {
      uniqueStrikes = Array.from(
        new Set(
          optionData.options
            ? optionData.options.map((option) => option.call.strike)
            : null
        )
      );
    }, 1000);
  }
  if (calls) {
    calls.sort((a, b) => a.strike - b.strike);
  }
  if (puts) {
    puts.sort((a, b) => a.strike - b.strike);
  }

  const checkIfPresentInBasket = (side, selectedOption, basketData) => {
    return basketData.some((position) => {
      const temp =
        side === "Call"
          ? selectedOption?.call?.trading_symbol
          : selectedOption?.put?.trading_symbol;

      return position.side === side && position.tradingSymbol === temp;
    });
  };

  const updateBasket = (trading_symbol, isBuy) => {
    setBasketData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.tradingSymbol === trading_symbol) {
          if (item.buy_sell === (isBuy ? "B" : "S")) {
            return null;
          } else {
            return { ...item, buy_sell: isBuy ? "B" : "S" };
          }
        }
        return item;
      });
      setBtnColor({ updatedData });
      // Remove null entries (items to be deleted)
      return updatedData.filter((item) => item !== null);
    });
  };

  const updateBuySellBasket = (trading_symbol, isBuy) => {
    setBuySellModalData((prevData) => {
      const updatedData = prevData.map((item) => {
        if (item.tradingSymbol === trading_symbol) {
          if (item.buy_sell === (isBuy ? "B" : "S")) {
            return null;
          } else {
            return { ...item, buy_sell: isBuy ? "B" : "S" };
          }
        }
        return item;
      });
      setBtnColor({ updatedData });
      // Remove null entries (items to be deleted)
      return updatedData.filter((item) => item !== null);
    });
  };

  //all buttons false if basket is empty
  if (basketData.length <= 0) {
    for (let i = 0; i < callsDataCon.length; i++) {
      if (callsDataCon[i]) {
        callsDataCon[i].buyBtnState = false;
        callsDataCon[i].sellBtnState = false;
      }
    }
    for (let i = 0; i < putsDataCon.length; i++) {
      if (putsDataCon[i]) {
        putsDataCon[i].buyBtnState = false;
        putsDataCon[i].sellBtnState = false;
      }
    }
  }

  //mapping the data to option chain on changing option chain
  if (basketData.length > 0) {
    for (let j = 0; j < callsDataCon.length; j++) {
      let matching_flag = false;
      for (let i = 0; i < basketData.length; i++) {
        const checkTradingSymbol = basketData[i].tradingSymbol;
        const direction = basketData[i].buy_sell;
        const side = basketData[i].side;
        if (side === "Call") {
          if (callsDataCon[j].trading_symbol === checkTradingSymbol) {
            matching_flag = true;
            callsDataCon[j].LotsSize = basketData[i].lotSize;
            if (direction === "B") {
              callsDataCon[j].buyBtnState = true;
              callsDataCon[j].sellBtnState = false;
            } else {
              callsDataCon[j].sellBtnState = true;
              callsDataCon[j].buyBtnState = false;
            }
          }
        }
      }
      if (!matching_flag) {
        callsDataCon[j].buyBtnState = false;
        callsDataCon[j].sellBtnState = false;
      }
    }

    for (let j = 0; j < putsDataCon.length; j++) {
      let matching_flag = false;
      for (let i = 0; i < basketData.length; i++) {
        const checkTradingSymbol = basketData[i].tradingSymbol;
        const direction = basketData[i].buy_sell;
        const side = basketData[i].side;
        if (side === "Put") {
          if (putsDataCon[j].trading_symbol === checkTradingSymbol) {
            matching_flag = true;
            putsDataCon[j].LotsSize = basketData[i].lotSize;
            if (direction === "B") {
              putsDataCon[j].buyBtnState = true;
              putsDataCon[j].sellBtnState = false;
            } else {
              putsDataCon[j].sellBtnState = true;
              putsDataCon[j].buyBtnState = false;
            }
          }
        }
      }
      if (!matching_flag) {
        putsDataCon[j].buyBtnState = false;
        putsDataCon[j].sellBtnState = false;
      }
    }
  }

  const [lotSizeInput, setLotSizeInput] = useState(1);

  const handleBuyClick = useCallback(
    async (selectedSide, rowIndex, lotsProp) => {
      // Scalp mode: directly place order and skip any button state logic
      if (isScalpOrderChecked) {
        const f = getReducedData();
        const selectedStrike = uniqueStrikes[rowIndex];
        const selectedOption = f?.[selectedStrike];
        if (!selectedOption) return;

        const side = selectedSide === "calls" ? "Call" : "Put";
        const price =
          selectedSide === "calls"
            ? symbolData[calls[rowIndex]?.code]?.ltp || 0
            : symbolData[puts[rowIndex]?.code]?.ltp || 0;
        const instrumentName =
          side === "Call"
            ? selectedOption.call.instrument_name
            : selectedOption.put.instrument_name;
        const lotSizeForOrder = Math.max(1, parseInt(lotsProp || 1, 10));
        const tradingSymbol =
          side === "Call"
            ? selectedOption.call.trading_symbol
            : selectedOption.put.trading_symbol;
        const expiryDate =
          side === "Call"
            ? selectedOption.call.expiry_date
            : selectedOption.put.expiry_date;
        const code = side === "Call" ? selectedOption.call.code : selectedOption.put.code;
        const underlying_code = selectedSymbol?.code;
        const strike = side === "Call" ? selectedOption.call.strike : selectedOption.put.strike;
        const exchange = side === "Call" ? selectedOption.call.exchange : selectedOption.put.exchange;
        const lot_multiplier =
          side === "Call"
            ? parseFloat(selectedOption.call.lot_size)
            : parseFloat(selectedOption.put.lot_size);

        const dataObject = {
          side,
          instrumentName,
          lotSize: lotSizeForOrder,
          optionType: side === "Call" ? "CE" : "PE",
          tradingSymbol,
          expiryDate,
          code,
          price,
          buy_sell: "B",
          underlying_code,
          strike,
          quantity: lot_multiplier,
          freeze_qty: side === "Call" ? selectedOption.call.freeze_qty : selectedOption.put.freeze_qty,
          exchange,
          lot_multiplier,
          scrip: selectedSymbol?.scrip,
        };

        if (isLive) {
          const payload = generateOrderPayload([dataObject]);
          const response = await sendOrder(payload);
          if (response.status) {
            toast.success(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-success-toast",
                icon: <img src={SuccessIcon} alt="Success Icon" />,
                onClick: () => handleToastToNavigate(response),
              }
            );
          } else {
            toast.error(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-error-toast",
                icon: <img src={ErrorIcon} alt="Error Icon" />,
              }
            );
          }
        } else {
          const payload = generateVirtualOrderPayload([dataObject]);
          const response = await sendVirtualOrder(payload);
          if (response.status) {
            toast.success(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-success-toast",
                icon: <img src={SuccessIcon} alt="Success Icon" />,
                onClick: () => handleToastToNavigate(response),
              }
            );
          } else {
            toast.error(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-error-toast",
                icon: <img src={ErrorIcon} alt="Error Icon" />,
              }
            );
          }
        }
        return;
      }

      setSelectedSide(selectedSide);
      if (callsDataCon && selectedSide === "calls") {
        const updatedCallsDataCon = [...callsDataCon];
        if (updatedCallsDataCon[rowIndex]) {
          setCallsDataCon(updatedCallsDataCon);
          if (updatedCallsDataCon[rowIndex].sellBtnState) {
            updatedCallsDataCon[rowIndex].sellBtnState = false;
          }
        } else {
          console.error(`Error: callsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: callsDataCon is undefined");
      }
      if (putsDataCon && selectedSide === "puts") {
        const updatedPutsDataCon = [...putsDataCon];
        if (updatedPutsDataCon[rowIndex]) {
          updatedPutsDataCon[rowIndex].buyBtnState =
            !updatedPutsDataCon[rowIndex].buyBtnState;
          // updatedPutsDataCon[rowIndex].LotsSize = lotSizeInput;
          setPutsDataCon(updatedPutsDataCon);
          if (updatedPutsDataCon[rowIndex].sellBtnState) {
            updatedPutsDataCon[rowIndex].sellBtnState = false;
          }
        } else {
          console.error(`Error: putsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: putsDataCon is undefined");
      }

      const d = getReducedData();
      const selectedStrike = uniqueStrikes[selectedRowIndex];
      const selectedOption = d[selectedStrike];
      const side = selectedSide === "calls" ? "Call" : "Put";
      const existingPositionIndex = checkIfPresentInBasket(
        side,
        selectedOption,
        basketData
      );
      const f = getReducedData();
      if (
        selectedSymbol &&
        reducedData &&
        selectedRowIndex !== null &&
        selectedSide !== null
      ) {
        // const selectedOption = f[selectedRowIndex];
        const selectedStrike = uniqueStrikes[selectedRowIndex]; // Get the selected strike value
        const selectedOption = f[selectedStrike]; // Use the strike value as the key
        // parseInt(lotSizeInput)
        const lotSizeForOrder = lotsProp;
        const side = selectedSide === "calls" ? "Call" : "Put";
        const instrumentName =
          side === "Call"
            ? selectedOption.call.instrument_name
            : selectedOption.put.instrument_name;

        //// console.log("instrumentName in buy click:", instrumentName);
        const price =
          selectedSide === "calls"
            ? symbolData[calls[selectedRowIndex]?.code]?.ltp || 0
            : symbolData[puts[selectedRowIndex]?.code]?.ltp || 0;
        const lotSize =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;
        const optionType = side === "Call" ? "CE" : "PE";
        const tradingSymbol =
          side === "Call"
            ? selectedOption.call.trading_symbol
            : selectedOption.put.trading_symbol;
        const expiryDate =
          side === "Call"
            ? selectedOption.call.expiry_date
            : selectedOption.put.expiry_date;
        const code =
          side === "Call" ? selectedOption.call.code : selectedOption.put.code;

        const buy_sell = "B";
        const underlying_code = selectedSymbol.code;
        const quantity =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;

        const strike =
          side === "Call"
            ? selectedOption.call.strike
            : selectedOption.put.strike;

        let freeze_qty =
          side === "Call"
            ? selectedOption.call.freeze_qty
            : selectedOption.put.freeze_qty;
        let exchange =
          side === "Call"
            ? selectedOption.call.exchange
            : selectedOption.put.exchange;
        let lot_multiplier =
          side === "Call"
            ? parseFloat(selectedOption.call.lot_size)
            : parseFloat(selectedOption.put.lot_size);

        const dataObject = {
          side,
          instrumentName,
          lotSize: lotSizeForOrder,
          optionType,
          tradingSymbol,
          expiryDate,
          code,
          price,
          buy_sell,
          underlying_code,
          strike,
          quantity,
          freeze_qty: freeze_qty,
          exchange: exchange,
          lot_multiplier: lot_multiplier,
          scrip: selectedSymbol.scrip,
        };
        if (isScalpOrderChecked) {
          if (isLive) {
            const payload = generateOrderPayload([dataObject]);
            const response = await sendOrder(payload);
            // // console.log("response", response);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          } else {
            const payload = generateVirtualOrderPayload([dataObject]);
            const response = await sendVirtualOrder(payload);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          }
          return;
        } else {
          parentCallback2([dataObject, "B"]);
          if (existingPositionIndex) {
            updateBasket(tradingSymbol, true);
          } else {
            addToBasket(dataObject);
            setDivVisibility(false);
            setBtnColor(dataObject);
            setLotSizeInput(1);
          }
        }
      }
      if (selectedSide === "calls") {
        const updatedTags = [...buySellTagsCalls];
        updatedTags[selectedRowIndex] = "buy";
        setBuySellTagsCalls(updatedTags);
      } else if (selectedSide === "puts") {
        const updatedTags = [...buySellTagsPuts];
        updatedTags[selectedRowIndex] = "buy";
        setBuySellTagsPuts(updatedTags);
      }
    },
    [
      lotSizeInput,
      objectData,
      selectedRowIndex,
      selectedSide,
      reducedData,
      basketData,
      optionData,
      removeFromBasket,
      setSelectedSide,
      uniqueStrikes,
    ]
  );

  const handleSellClick = useCallback(
    async (selectedSide, rowIndex, lotsProp) => {
      // Scalp mode: directly place order and skip any button state logic
      if (isScalpOrderChecked) {
        const f = getReducedData();
        const selectedStrike = uniqueStrikes[rowIndex];
        const selectedOption = f?.[selectedStrike];
        if (!selectedOption) return;

        const side = selectedSide === "calls" ? "Call" : "Put";
        const price =
          selectedSide === "calls"
            ? symbolData[calls[rowIndex]?.code]?.ltp || 0
            : symbolData[puts[rowIndex]?.code]?.ltp || 0;
        const instrumentName =
          side === "Call"
            ? selectedOption.call.instrument_name
            : selectedOption.put.instrument_name;
        const lotSizeForOrder = Math.max(1, parseInt(lotsProp || 1, 10));
        const tradingSymbol =
          side === "Call"
            ? selectedOption.call.trading_symbol
            : selectedOption.put.trading_symbol;
        const expiryDate =
          side === "Call"
            ? selectedOption.call.expiry_date
            : selectedOption.put.expiry_date;
        const code = side === "Call" ? selectedOption.call.code : selectedOption.put.code;
        const underlying_code = selectedSymbol?.code;
        const strike = side === "Call" ? selectedOption.call.strike : selectedOption.put.strike;
        const exchange = side === "Call" ? selectedOption.call.exchange : selectedOption.put.exchange;
        const lot_multiplier =
          side === "Call"
            ? parseFloat(selectedOption.call.lot_size)
            : parseFloat(selectedOption.put.lot_size);

        const dataObject = {
          side,
          instrumentName,
          lotSize: lotSizeForOrder,
          optionType: side === "Call" ? "CE" : "PE",
          tradingSymbol,
          expiryDate,
          code,
          price,
          buy_sell: "S",
          underlying_code,
          strike,
          quantity: lot_multiplier,
          freeze_qty: side === "Call" ? selectedOption.call.freeze_qty : selectedOption.put.freeze_qty,
          exchange,
          lot_multiplier,
          scrip: selectedSymbol?.scrip,
        };

        if (isLive) {
          const payload = generateOrderPayload([dataObject]);
          const response = await sendOrder(payload);
          if (response.status) {
            toast.success(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-success-toast",
                icon: <img src={SuccessIcon} alt="Success Icon" />,
                onClick: () => handleToastToNavigate(response),
              }
            );
          } else {
            toast.error(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-error-toast",
                icon: <img src={ErrorIcon} alt="Error Icon" />,
              }
            );
          }
        } else {
          const payload = generateVirtualOrderPayload([dataObject]);
          const response = await sendVirtualOrder(payload);
          if (response.status) {
            toast.success(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-success-toast",
                icon: <img src={SuccessIcon} alt="Success Icon" />,
                onClick: () => handleToastToNavigate(response),
              }
            );
          } else {
            toast.error(
              <CustomToastContent
                heading={response.message_header}
                message={response.message_body}
              />,
              {
                className: "custom-error-toast",
                icon: <img src={ErrorIcon} alt="Error Icon" />,
              }
            );
          }
        }
        return;
      }

      if (objectData.isBuy) {
        setObjectData({ ...objectData, isBuy: false });
      } else {
        setObjectData({ ...objectData, isBuy: true });
      }

      setSelectedSide(selectedSide);
      if (callsDataCon && selectedSide === "calls") {
        const updatedCallsDataCon = [...callsDataCon];
        if (updatedCallsDataCon[rowIndex]) {
          updatedCallsDataCon[rowIndex].sellBtnState =
            !updatedCallsDataCon[rowIndex].sellBtnState;
          if (updatedCallsDataCon[rowIndex].buyBtnState) {
            updatedCallsDataCon[rowIndex].buyBtnState = false;
          }

          setCallsDataCon(updatedCallsDataCon);
        } else {
          console.error(`Error: callsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: callsDataCon is undefined");
      }
      if (putsDataCon && selectedSide === "puts") {
        const updatedPutsDataCon = [...putsDataCon];
        if (updatedPutsDataCon[rowIndex]) {
          updatedPutsDataCon[rowIndex].sellBtnState =
            !updatedPutsDataCon[rowIndex].sellBtnState;
          if (updatedPutsDataCon[rowIndex].buyBtnState) {
            updatedPutsDataCon[rowIndex].buyBtnState = false;
          }
          setPutsDataCon(updatedPutsDataCon);
        } else {
          console.error(`Error: putsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: putsDataCon is undefined");
      }

      const d = getReducedData();
      const selectedStrike = uniqueStrikes[selectedRowIndex];
      const selectedOption = d[selectedStrike];
      const side = selectedSide === "calls" ? "Call" : "Put";
      const existingPositionIndex = checkIfPresentInBasket(
        side,
        selectedOption,
        basketData
      );
      const f = getReducedData();

      if (
        selectedSymbol &&
        reducedData &&
        selectedRowIndex !== null &&
        selectedSide !== null
      ) {
        //// console.log("Selected Row Indexxxx:", selectedRowIndex);
        const selectedStrike = uniqueStrikes[selectedRowIndex]; // Get the selected strike value
        const selectedOption = f[selectedStrike]; // Use the strike value as the key
        //  // console.log("Selected Option in handleSellClick:", selectedOption);

        const lotSizeForOrder = lotsProp;
        const side = selectedSide === "calls" ? "Call" : "Put";
        const price =
          selectedSide === "calls"
            ? symbolData[calls[selectedRowIndex]?.code]?.ltp || 0
            : symbolData[puts[selectedRowIndex]?.code]?.ltp || 0;
        const instrumentName =
          side === "Call"
            ? selectedOption.call.instrument_name
            : selectedOption.put.instrument_name;
        const lotSize =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;
        const optionType = side === "Call" ? "CE" : "PE";
        const tradingSymbol =
          side === "Call"
            ? selectedOption.call.trading_symbol
            : selectedOption.put.trading_symbol;
        const expiryDate =
          side === "Call"
            ? selectedOption.call.expiry_date
            : selectedOption.put.expiry_date;

        const quantity =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;

        const strike =
          side === "Call"
            ? selectedOption.call.strike
            : selectedOption.put.strike;
        const code =
          side === "Call" ? selectedOption.call.code : selectedOption.put.code;

        const buy_sell = "S";
        const underlying_code = selectedSymbol.code;
        let freeze_qty =
          side === "Call"
            ? selectedOption.call.freeze_qty
            : selectedOption.put.freeze_qty;
        let exchange =
          side === "Call"
            ? selectedOption.call.exchange
            : selectedOption.put.exchange;
        let lot_multiplier =
          side === "Call"
            ? parseFloat(selectedOption.call.lot_size)
            : parseFloat(selectedOption.put.lot_size);

        const dataObject = {
          side,
          instrumentName,
          lotSize: lotSizeForOrder,
          optionType,
          tradingSymbol,
          expiryDate,
          code,
          price,
          buy_sell,
          underlying_code,
          strike,
          quantity,
          freeze_qty: freeze_qty,
          exchange: exchange,
          lot_multiplier: lot_multiplier,
          scrip: selectedSymbol.scrip,
        };
        if (isScalpOrderChecked) {
          if (isLive) {
            const payload = generateOrderPayload([dataObject]);
            const response = await sendOrder(payload);
            // // console.log("response", response);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          } else {
            const payload = generateVirtualOrderPayload([dataObject]);
            const response = await sendVirtualOrder(payload);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          }
          return;
        } else {
          parentCallback2([dataObject, "S"]);
          if (existingPositionIndex) {
            updateBasket(tradingSymbol, false);
          } else {
            addToBasket(dataObject);
            setDivVisibility(false);
            setBtnColor(dataObject);
            setLotSizeInput(1);
          }
        }
        if (selectedSide === "calls") {
          const updatedTags = [...buySellTagsCalls];
          updatedTags[selectedRowIndex] = "sell";
          setBuySellTagsCalls(updatedTags);
        } else if (selectedSide === "puts") {
          const updatedTags = [...buySellTagsPuts];
          updatedTags[selectedRowIndex] = "sell";
          setBuySellTagsPuts(updatedTags);
        }
      }
    },
    [
      lotSizeInput,
      optionData,
      uniqueStrikes,
      reducedData,
      lotSizeInput,
      basketData,
      removeFromBasket,
      setSelectedSide,
      uniqueStrikes,
      selectedRowIndex,
      selectedSide,
      optionData,
      uniqueStrikes,
      lotSizeInput,
    ]
  );

  const handleBuySellModalClick = useCallback(
    async (selectedSide, rowIndex, lotsProp) => {
      // // console.log(
      //   "selectedSide, rowIndex, lotsProp",
      //   selectedSide,
      //   rowIndex,
      //   lotsProp
      // );
      setSelectedSide(selectedSide);
      if (callsDataCon && selectedSide === "calls") {
        const updatedCallsDataCon = [...callsDataCon];
        if (updatedCallsDataCon[rowIndex]) {
          updatedCallsDataCon[rowIndex].sellBtnState =
            !updatedCallsDataCon[rowIndex].sellBtnState;
          if (updatedCallsDataCon[rowIndex].buyBtnState) {
            updatedCallsDataCon[rowIndex].buyBtnState = false;
          }

          setCallsDataCon(updatedCallsDataCon);
        } else {
          console.error(`Error: callsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: callsDataCon is undefined");
      }
      if (putsDataCon && selectedSide === "puts") {
        const updatedPutsDataCon = [...putsDataCon];
        if (updatedPutsDataCon[rowIndex]) {
          updatedPutsDataCon[rowIndex].sellBtnState =
            !updatedPutsDataCon[rowIndex].sellBtnState;
          if (updatedPutsDataCon[rowIndex].buyBtnState) {
            updatedPutsDataCon[rowIndex].buyBtnState = false;
          }
          setPutsDataCon(updatedPutsDataCon);
        } else {
          console.error(`Error: putsDataCon[${rowIndex}] is undefined`);
        }
      } else {
        console.error("Error: putsDataCon is undefined");
      }

      const d = getReducedData();
      const selectedStrike = uniqueStrikes[selectedRowIndex];
      const selectedOption = d[selectedStrike];
      const side = selectedSide === "calls" ? "Call" : "Put";
      const existingPositionIndex = checkIfPresentInBasket(
        side,
        selectedOption,
        buySellModalData
      );
      const f = getReducedData();

      if (
        selectedSymbol &&
        reducedData &&
        selectedRowIndex !== null &&
        selectedSide !== null
      ) {
        //// console.log("Selected Row Indexxxx:", selectedRowIndex);
        const selectedStrike = uniqueStrikes[selectedRowIndex]; // Get the selected strike value
        const selectedOption = f[selectedStrike]; // Use the strike value as the key
        //  // console.log("Selected Option in handleSellClick:", selectedOption);

        const lotSizeForOrder = lotsProp;
        const side = selectedSide === "calls" ? "Call" : "Put";
        const price =
          selectedSide === "calls"
            ? symbolData[calls[selectedRowIndex]?.code]?.ltp || 0
            : symbolData[puts[selectedRowIndex]?.code]?.ltp || 0;
        const trigger_price =
          selectedSide === "calls"
            ? symbolData[calls[selectedRowIndex]?.code]?.ltp || 0
            : symbolData[puts[selectedRowIndex]?.code]?.ltp || 0;
        const instrumentName =
          side === "Call"
            ? selectedOption.call.instrument_name
            : selectedOption.put.instrument_name;
        const lot_size =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;
        const optionType = side === "Call" ? "CE" : "PE";
        const tradingSymbol =
          side === "Call"
            ? selectedOption.call.trading_symbol
            : selectedOption.put.trading_symbol;
        const expiryDate =
          side === "Call"
            ? selectedOption.call.expiry_date
            : selectedOption.put.expiry_date;

        const quantity =
          side === "Call"
            ? selectedOption.call.lot_size
            : selectedOption.put.lot_size;

        const strike =
          side === "Call"
            ? selectedOption.call.strike
            : selectedOption.put.strike;
        const code =
          side === "Call" ? selectedOption.call.code : selectedOption.put.code;

        const buy_sell = "B";
        const underlying_code = selectedSymbol.code;
        let freeze_qty =
          side === "Call"
            ? selectedOption.call.freeze_qty
            : selectedOption.put.freeze_qty;
        let exchange =
          side === "Call"
            ? selectedOption.call.exchange
            : selectedOption.put.exchange;
        let lot_multiplier = parseFloat(optionData?.lot_size);

        const dataObject = {
          side,
          instrumentName,
          lotSize: lotSizeForOrder,
          lot_size,
          optionType,
          tradingSymbol,
          expiryDate,
          code,
          price,
          trigger_price,
          buy_sell,
          underlying_code,
          strike,
          quantity,
          freeze_qty: freeze_qty,
          exchange: exchange,
          lot_multiplier: lot_multiplier,
          scrip: selectedSymbol.scrip,
        };
        if (isScalpOrderChecked) {
          if (isLive) {
            const payload = generateOrderPayload([dataObject]);
            const response = await sendOrder(payload);
            // // console.log("response", response);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          } else {
            const payload = generateVirtualOrderPayload([dataObject]);
            const response = await sendVirtualOrder(payload);
            if (response.status) {
              toast.success(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-success-toast",
                  icon: <img src={SuccessIcon} alt="Success Icon" />,
                  onClick: () => handleToastToNavigate(response),
                }
              );
            } else {
              toast.error(
                <CustomToastContent
                  heading={response.message_header}
                  message={response.message_body}
                />,
                {
                  className: "custom-error-toast",
                  icon: <img src={ErrorIcon} alt="Error Icon" />,
                }
              );
            }
          }
          return;
        } else {
          parentCallback2([dataObject, "S"]);
          if (existingPositionIndex) {
            updateBuySellBasket(tradingSymbol, false);
          } else {
            addToBuySellModal(dataObject);
            setDivVisibility(false);
            setBtnColor(dataObject);
            setLotSizeInput(1);
          }
        }
        if (selectedSide === "calls") {
          const updatedTags = [...buySellTagsCalls];
          updatedTags[selectedRowIndex] = "sell";
          setBuySellTagsCalls(updatedTags);
        } else if (selectedSide === "puts") {
          const updatedTags = [...buySellTagsPuts];
          updatedTags[selectedRowIndex] = "sell";
          setBuySellTagsPuts(updatedTags);
        }
      }
    },
    [
      lotSizeInput,
      optionData,
      uniqueStrikes,
      reducedData,
      lotSizeInput,
      basketData,
      removeFromBasket,
      setSelectedSide,
      uniqueStrikes,
      selectedRowIndex,
      selectedSide,
      optionData,
      uniqueStrikes,
      lotSizeInput,
    ]
  );

  useEffect(() => {
    if (symbol) {
      const symbolCode = symbol.code;
      const ltpValue = symbolData[symbolCode]?.ltp || 0;
      setLtp(ltpValue);
    }
  }, [selectedSymbol, symbolData, symbol]);

  useEffect(() => {
    const computeGreeks = () => {
      // // console.log("Computing");
      const spot = parseFloat(symbolData[symbol?.code]?.ltp);
      const riskFreeRate = 0.06504;
      
      // Validate spot price before proceeding
      if (!spot || isNaN(spot) || spot <= 0) {
        return; // Exit early if spot price is invalid
      }
      
      calls?.forEach((call_option, i) => {
        const strike = parseFloat(call_option?.strike);
        const targetDateTimeString = call_option.expiry_date + " 15:29:59";
        const targetDateTime = new Date(targetDateTimeString);
        let currentDate = new Date();
        const cutoff = new Date();
        cutoff.setHours(15, 30, 0, 0);
        if (currentDate > cutoff) {
          currentDate = cutoff;
        }
        let timeToExpiration =
          (targetDateTime - currentDate) / (24 * 60 * 60 * 365.25 * 1000);
        if (strike !== 0 && timeToExpiration >= 0 && selectedSymbol?.scrip) {
          const isCallOption = strike > spot;
          const optionType = isCallOption ? "call" : "put";
          const relevantOption = isCallOption ? call_option : puts[i];
          let initialGuessIv;
          if (symbolData[relevantOption?.code] && !relevantOption.iv) {
            const currentStockPrice = parseFloat(
              symbolData[relevantOption?.code]?.ltp
            );
            
            // Validate currentStockPrice before IV calculation
            if (!currentStockPrice || isNaN(currentStockPrice) || currentStockPrice <= 0) {
              return; // Skip this iteration if stock price is invalid
            }
            
            try {
              initialGuessIv = iv.getImpliedVolatility(
                currentStockPrice,
                spot,
                strike,
                timeToExpiration,
                riskFreeRate,
                optionType
              );
            } catch (error) {
              console.warn("IV calculation error:", error);
              return; // Skip this iteration if IV calculation fails
            }
          }
          
          // Enhanced validation for IV result
          if (!isNaN(initialGuessIv) && initialGuessIv >= 0 && initialGuessIv <= 5) {
            call_option.iv = (initialGuessIv * 100).toFixed(2);
            
            // Safe Greeks calculations with error handling
            try {
              call_option.delta = greeks
                .getDelta(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "call"
                )
                .toFixed(2);
              call_option.theta = greeks
                .getTheta(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "call"
                )
                .toFixed(2);
              call_option.gamma = greeks
                .getGamma(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "call"
                )
                .toFixed(4);
              call_option.vega = greeks
                .getVega(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "call"
                )
                .toFixed(2);
              call_option.rho = greeks
                .getRho(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "call"
                )
                .toFixed(2);
            } catch (error) {
              console.warn("Greeks calculation error for calls:", error);
              // Set default values if calculation fails
              call_option.delta = "0.00";
              call_option.theta = "0.00";
              call_option.gamma = "0.0000";
              call_option.vega = "0.00";
              call_option.rho = "0.00";
            }

            puts[i].iv = (initialGuessIv * 100).toFixed(2);
            
            // Safe Greeks calculations for puts with error handling
            try {
              puts[i].delta = greeks
                .getDelta(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "put"
                )
                .toFixed(2);
              puts[i].theta = greeks
                .getTheta(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "put"
                )
                .toFixed(2);
              puts[i].gamma = greeks
                .getGamma(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "put"
                )
                .toFixed(4);
              puts[i].vega = greeks
                .getVega(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "put"
                )
                .toFixed(2);
              puts[i].rho = greeks
                .getRho(
                  spot,
                  strike,
                  timeToExpiration,
                  initialGuessIv,
                  riskFreeRate,
                  "put"
                )
                .toFixed(2);
            } catch (error) {
              console.warn("Greeks calculation error for puts:", error);
              // Set default values if calculation fails
              puts[i].delta = "0.00";
              puts[i].theta = "0.00";
              puts[i].gamma = "0.0000";
              puts[i].vega = "0.00";
              puts[i].rho = "0.00";
            }
          }
        }
      });
    };

    computeGreeks();
  }, [symbolData, atmIndex, selectedSymbol, calls, puts]);

  // useEffect(() => {
  //     if (!workerRef.current) {
  //       workerRef.current = new GreeksWorker();
  //     }

  //     const spot = parseFloat(symbolData[selectedSymbol?.code]?.ltp);
  //     const riskFreeRate = 0.064515;

  //     workerRef.current.postMessage({
  //       spot,
  //       riskFreeRate,
  //       calls,
  //       puts,
  //       symbolData,
  //       selectedSymbol,
  //     });

  //     workerRef.current.onmessage = (e) => {
  //       const greeksResults = e.data;
  //       greeksResults.forEach(({ i, call, put }) => {
  //         Object.assign(calls[i], call);
  //         Object.assign(puts[i], put);
  //       });
  //     };

  //     return () => {
  //       workerRef.current.terminate();
  //       workerRef.current = null;
  //     };
  //   }, [symbolData, atmIndex, selectedSymbol, calls, puts]);

  const callsColSpan = showCalls ? 8 : 0;
  const putsColSpan = showPuts ? 7 : 0;

  // Formatting volume
  function formatVolume(volume) {
    if (volume >= 10000000) {
      return `${(volume / 10000000).toFixed(2)}Cr`;
    } else if (volume >= 100000) {
      return `${(volume / 100000).toFixed(2)}L`;
    } else if (volume >= 1000) {
      return `${(volume / 1000).toFixed(2)}K`;
    } else {
      if (isNaN(volume)) {
        return "0";
      }
      return `${volume}`;
    }
  }

  const [buySellTagsCalls, setBuySellTagsCalls] = useState(
    calls ? new Array(calls.length).fill(null) : []
  );

  const [buySellTagsPuts, setBuySellTagsPuts] = useState(
    puts ? new Array(puts.length).fill(null) : []
  );

  const [scrollValue, setScrollValue] = useState(0);

  // Function to handle range input change
  const handleRangeChange = (e) => {
    setScrollValue(e.target.value);
    // Calculate the scroll position based on the range input value
    const scrollPosition =
      (e.target.value / 100) *
      (containerRef.current.scrollWidth - containerRef.current.clientWidth);
    containerRef.current.scrollLeft = scrollPosition;
  };
  // Function to handle table scroll
  const handleScroll = () => {
    // Calculate the range input value based on the scroll position
    const scrollValue =
      (containerRef.current.scrollLeft /
        (containerRef.current.scrollWidth - containerRef.current.clientWidth)) *
      100;
    setScrollValue(scrollValue);
  };

  //// console.log("maxPain in table", maxPain);

  const callHeaderRef = useRef(null);
  const putHeaderRef = useRef(null);
  const callBodyRef = useRef(null);
  const putBodyRef = useRef(null);
  const centerRef = useRef(null);

  const isSyncingHorizontal = useRef(false);
  const isSyncingVertical = useRef(false);

  const getMaxScrollLeft = () => {
    if (callBodyRef.current)
      return callBodyRef.current.scrollWidth - callBodyRef.current.clientWidth;
    if (putBodyRef.current)
      return putBodyRef.current.scrollWidth - putBodyRef.current.clientWidth;
    return null;
  };

  const syncHorizontalScroll = (sourceRef, from) => {
    if (isSyncingHorizontal.current) return;
    isSyncingHorizontal.current = true;

    const callMax = getMaxScrollLeft();

    if (callMax === null) {
      isSyncingHorizontal.current = false;
      return;
    }

    let scrollLeft = sourceRef.current.scrollLeft;
    let mirroredScroll = callMax - scrollLeft;

    if (from.startsWith("put")) {
      scrollLeft = callMax - scrollLeft;
      mirroredScroll = callMax - scrollLeft;
    }

    if (from !== "callHeader" && callHeaderRef.current)
      callHeaderRef.current.scrollLeft = scrollLeft;
    if (from !== "callBody" && callBodyRef.current)
      callBodyRef.current.scrollLeft = scrollLeft;

    if (from !== "putHeader" && putHeaderRef.current)
      putHeaderRef.current.scrollLeft = mirroredScroll;
    if (from !== "putBody" && putBodyRef.current)
      putBodyRef.current.scrollLeft = mirroredScroll;

    requestAnimationFrame(() => {
      isSyncingHorizontal.current = false;
    });
  };

  const syncVerticalScroll = (sourceRef) => {
    if (isSyncingVertical.current) return;
    isSyncingVertical.current = true;

    const scrollTop = sourceRef.current?.scrollTop;
    if (scrollTop == null) {
      isSyncingVertical.current = false;
      return;
    }

    // Only mark as user scroll if it's not programmatic
    if (!isProgrammaticScroll.current) {
      setUserHasScrolled(true);
    }

    if (callBodyRef.current && callBodyRef.current !== sourceRef) {
      callBodyRef.current.scrollTop = scrollTop;
    }

    if (centerRef.current && centerRef.current !== sourceRef) {
      centerRef.current.scrollTop = scrollTop;
    }

    if (putBodyRef.current && putBodyRef.current !== sourceRef) {
      putBodyRef.current.scrollTop = scrollTop;
    }

    requestAnimationFrame(() => {
      isSyncingVertical.current = false;
    });
  };

  const scrollAllToAtm = () => {
    isProgrammaticScroll.current = true;
    const target = targetRowRef.current;
    const container = putBodyRef.current || callBodyRef.current || centerRef.current;
    if (target && container) {
      const top = target.offsetTop;
      const height = target.offsetHeight;
      const visibleHeight = container.clientHeight;
      const scrollTop = top - visibleHeight / 2.1 + height / 2;
      if (callBodyRef.current) callBodyRef.current.scrollTop = scrollTop;
      if (centerRef.current) centerRef.current.scrollTop = scrollTop;
      if (putBodyRef.current) putBodyRef.current.scrollTop = scrollTop;
    } else if (centerRef.current) {
      const scrollTop = centerRef.current.scrollTop;
      if (callBodyRef.current) callBodyRef.current.scrollTop = scrollTop;
      if (putBodyRef.current) putBodyRef.current.scrollTop = scrollTop;
    }
    setTimeout(() => {
      isProgrammaticScroll.current = false;
    }, 100);
  };

  const syncAllScrollPositions = () => {
    // Horizontal: calls scroll to max (LTP near strike), puts scroll to 0 (LTP near strike)
    const callMax = getMaxScrollLeft();
    if (callMax !== null) {
      if (callBodyRef.current) callBodyRef.current.scrollLeft = callMax;
      if (callHeaderRef.current) callHeaderRef.current.scrollLeft = callMax;
      if (putBodyRef.current) putBodyRef.current.scrollLeft = 0;
      if (putHeaderRef.current) putHeaderRef.current.scrollLeft = 0;
    }
    // Vertical: scroll to ATM
    scrollAllToAtm();
  };

  // Sync scroll on initial mount
  useEffect(() => {
    const timer = setTimeout(syncAllScrollPositions, 50);
    return () => clearTimeout(timer);
  }, []);

  // Sync scroll when sides are toggled
  useEffect(() => {
    const timer = setTimeout(syncAllScrollPositions, 100);
    return () => clearTimeout(timer);
  }, [showCalls, showPuts]);

  // Reset scroll flags when symbol or expiry changes
  useEffect(() => {
    setHasInitialScrolled(false);
    setUserHasScrolled(false);
  }, [symbol?.code, selectedDate]);

  // Auto-scroll to ATM row when data changes (but not after user has manually scrolled)
  useEffect(() => {
    if (!userHasScrolled) {
      const timer = setTimeout(scrollAllToAtm, 50);
      return () => clearTimeout(timer);
    }
  }, [puts, calls, atmIndex, selectedSymbol, selectedDate, userHasScrolled]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [modalAction, setModalAction] = useState(null);
  const [isMarketDepthOpen, setIsMarketDepthOpen] = useState(false);
  const [marketDepthInstrument, setMarketDepthInstrument] = useState(null);
  const [marketDepthGeom, setMarketDepthGeom] = useState(null);
  const [buySellInitialPos, setBuySellInitialPos] = useState(null);

  const [isWatchlistModalOpen, setIsWatchlistModalOpen] = useState(false);
  const [watchlistInstrument, setWatchlistInstrument] = useState(null);

  const openAddToWatchlist = (ins) => {
    setWatchlistInstrument(ins);
    setIsWatchlistModalOpen(true);
  };
  const closeAddToWatchlist = () => {
    setIsWatchlistModalOpen(false);
    setWatchlistInstrument(null);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedPosition(null);
  };

  const fetchOrders = () => {
    // console.log("Fetching updated orders");
  };

  const openMarketDepth = (instrument) => {
    setMarketDepthInstrument(instrument);
    setIsMarketDepthOpen(true);
  };

  const closeMarketDepth = () => {
    setIsMarketDepthOpen(false);
    setMarketDepthInstrument(null);
  };

  const handleMarketDepthBuySell = (instrument, isBuy) => {
    const ltpPrice = symbolData[instrument.code]?.ltp;
    const actualInstrument = instrument.isCall
      ? calls?.find((c) => c.code === instrument.code)
      : puts?.find((p) => p.code === instrument.code);

    const actualLotSize = actualInstrument?.lot_size || 1;
    const lotSizeForOrder = Math.max(1, parseInt(scalpLots || 1, 10));
    const data_object = {
      side: isBuy ? "Buy" : "Sell",
      instrumentName: instrument.instrumentName || instrument.instrument_name,
      lotSize: Math.max(1, parseInt(scalpLots || 1, 10)),
      lot_size: actualLotSize,
      productType: "Normal",
      tradingSymbol: instrument.trading_symbol,
      expiryDate: instrument.expiry_date,
      code: instrument.code,
      price: ltpPrice || 0,
      trigger_price: ltpPrice || 0,
      buy_sell: isBuy ? "B" : "S",
      underlying_code: instrument.underlying_code,
      strike: instrument.strike,
      quantity: actualLotSize * lotSizeForOrder ,
      // quantity: instrument.originalInstrument?.lot_size || 1,
      exchange: instrument.exchange,
      scrip: instrument.underlying_symbol,
      lot_multiplier: 1,
      isCall: instrument.isCall,
    };

    // If scalp mode is enabled on Charts page, directly execute order instead of opening modal
    if (isFromCharts && isScalpOrderChecked) {
      const payload = isLive
        ? generateOrderPayload([data_object])
        : generateVirtualOrderPayload([data_object]);
      (isLive ? sendOrder(payload) : sendVirtualOrder(payload));
      toast.success(
        <CustomToastContent
          heading="Order placed successfully"
          message="Scalp order placed from Market Depth"
        />,
        {
          className: "custom-success-toast",
          icon: <img src={SuccessIcon} alt="Success Icon" />,
        }
      );
      // Close Market Depth only in scalp mode
      closeMarketDepth();
      return;
    }

    // Otherwise open regular buy/sell modal
    setBuySellModalData([data_object]);
    setModalAction("add");
    // If Market Depth is visible and we have its geometry, open Buy/Sell to the right of it
    if (isMarketDepthOpen && marketDepthGeom) {
      const gap = 12;
      const rightX = Math.min(
        window.innerWidth - 480 - 8,
        marketDepthGeom.x + marketDepthGeom.width + gap
      );
      const y = marketDepthGeom.y;
      setModalOpen(true);
      setTimeout(() => {
        // pass initial position via state prop below
      }, 0);
      setBuySellInitialPos({ x: rightX, y });
    } else {
      setBuySellInitialPos(null);
      setModalOpen(true);
    }
  };

  // If neither Calls nor Puts are selected, hide the table entirely and show a hint
  if (!showCalls && !showPuts) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <div className="text-n500 text-center text-sm">
          Select Calls or Puts from configure settings to view the table
        </div>
      </div>
    );
  }

  return (
    <div className={`max-w-[100%] ${isFromCharts ? 'h-full flex flex-col' : ''}`}>
      <div className={isFromCharts ? 'flex flex-col flex-1 min-h-0' : 'mb-4'}>
        <BuySellModal
          modalOpen={modalOpen}
          modalClose={closeModal}
          isOrders={false}
          setIsBuySellModalOpen={setModalOpen}
          fetchOrders={fetchOrders}
          initialData={selectedPosition}
          action={modalAction}
          handleAddToBasket={handleAddToBasket}
          isFromCharts={isFromCharts}
          initialPosition={buySellInitialPos}
        />
        <MarketDepthModal
          isOpen={isMarketDepthOpen}
          onClose={closeMarketDepth}
          instrument={marketDepthInstrument}
          onBuySellClick={handleMarketDepthBuySell}
          onPositionChange={(geom) => setMarketDepthGeom(geom)}
        />
        <AddToWatchlistModal
          isOpen={isWatchlistModalOpen}
          onClose={closeAddToWatchlist}
          instrument={watchlistInstrument}
        />

        <div
          className="flex w-full bg-p400 py-2 font-medium text-center text-[12px] text-p300 rounded-t-md">
          <div className={showCalls ? 'flex-1' : 'hidden'}>
            {" "}
            {showCalls && "Calls"}
          </div>
          <div className="shrink-0 px-6 text-center">
            Strike & IV
          </div>
          <div className={showPuts ? 'flex-1' : 'hidden'}>
            {" "}
            {showPuts && "Puts"}
          </div>
        </div>

        <div className="flex w-full bg-p400 text-n600 text-[10px] text-center">
          {showCalls && (
            <div
              className="overflow-x-auto no-scrollbar flex-1 min-w-0"
              ref={callHeaderRef}
              onScroll={() =>
                syncHorizontalScroll(callHeaderRef, "callHeader")
              }>
              <div className="min-w-max w-full expanded-table-cols flex font-medium">
                {showRho && (
                  <div className="p-2 w-32 border border-n100">Rho</div>
                )}
                {showVega && (
                  <div className="p-2 w-32 border border-n100">Vega</div>
                )}
                {showGamma && (
                  <div className="p-2 w-32 border border-n100">Gamma</div>
                )}
                {showTheta && (
                  <div className="p-2 w-32 border border-n100">Theta</div>
                )}
                {showDelta && (
                  <div className="p-2 w-32 border border-n100">Delta</div>
                )}
                <div className="p-2 w-32 border border-n100">Volume</div>
                <div className="p-2 w-32 border border-n100">Analysis</div>
                <div className="p-2 w-32 border border-n100"> OI Chg %</div>
                <div className="p-2 w-28 border border-n100"> OI </div>
                {/* <div className="p-2 w-32 border border-n100">  LTP Chg </div> */}
                <div className="p-2 w-44 border border-n100"> LTP </div>
              </div>
            </div>
          )}
          <div className="shrink-0">
            <div className="flex">
              <div className="p-2 w-32 border border-n100 font-medium">
                Strike
              </div>
              <div className="p-2 w-32 border border-n100 font-medium">IV</div>
            </div>
          </div>
          {showPuts && (
            <div
              className="overflow-x-auto no-scrollbar flex-1 min-w-0"
              ref={putHeaderRef}
              onScroll={() => syncHorizontalScroll(putHeaderRef, "putHeader")}>
              <div className="min-w-max w-full expanded-table-cols flex font-medium">
                <div className="p-2 w-44 border border-n100">LTP</div>
                {/* <div className="p-2 w-32 border border-n100">LTP Chg</div> */}
                <div className="p-2 w-28 border border-n100">OI</div>
                <div className="p-2 w-32 border border-n100"> OI Chg %</div>
                <div className="p-2 w-32 border border-n100">Analysis</div>
                <div className="p-2 w-32 border border-n100">Volume</div>
                {showDelta && (
                  <div className="p-2 w-32 border border-n100">Delta</div>
                )}
                {showTheta && (
                  <div className="p-2 w-32 border border-n100">Theta</div>
                )}
                {showGamma && (
                  <div className="p-2 w-32 border border-n100">Gamma</div>
                )}
                {showVega && (
                  <div className="p-2 w-32 border border-n100">Vega</div>
                )}
                {showRho && (
                  <div className="p-2 w-32 border border-n100">Rho</div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className={`flex w-full ${isFromCharts ? 'flex-1 min-h-0' : 'h-[600px]'} relative font-semibold bg-p400`}>
          {showCalls && (
            <div
              className="h-scrollbar-only text-[12px] text-p300 text-center bg-p400 flex-1 min-w-0"
              ref={callBodyRef}
              onScroll={() => {
                syncVerticalScroll(callBodyRef);
                syncHorizontalScroll(callBodyRef, "callBody");
              }}>
              <div className="min-w-max w-full expanded-table-cols">
                {calls.map((call, index) => (
                  <div
                    key={index}
                    className="flex"
                    onMouseEnter={() => handleRowMouseEnter(index)}
                    onMouseLeave={handleRowMouseLeave}>
                    {!selectedData?.some((item) => item.code === call.code) &&
                    selectedRowIndex === index &&
                    divVisibility ? (
                      <div
                        className="sticky left-4 z-10 bg-transparent"
                        style={{ minWidth: "0px" }}>
                        <div className="absolute left-0 top-1 flex gap-1 items-center px-2 z-20">
                          <button
                            className={`p-2 py-0.5 rounded-sm text-white font-medium bg-p150 ${callsDataCon[index]?.buyBtnState ? "active" : ""}`}
                            onClick={() => {
                              if (isScalpOrderChecked && scalpLots) {
                                handleBuyClick("calls", index, scalpLots);
                              } else if (directAddToBasket) {
                                handleDirectAddToBasket(call, true, true);
                              } else {
                                handleAddModal(call, index, true, true);
                              }
                            }}>
                            B
                          </button>
                          <button
                            className={`p-2 py-0.5 rounded-sm text-white font-medium bg-red ${callsDataCon[index]?.sellBtnState ? "active" : ""}`}
                            onClick={() => {
                              if (isScalpOrderChecked && scalpLots) {
                                handleSellClick("calls", index, scalpLots);
                              } else if (directAddToBasket) {
                                handleDirectAddToBasket(call, false, true);
                              } else {
                                handleAddModal(call, index, false, true);
                              }
                            }}>
                            S
                          </button>

                          {/* Chart navigation icon */}
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Market Depth"
                            onClick={() =>
                              openMarketDepth({
                                code: call.code,
                                instrumentName: call.instrument_name,
                                trading_symbol: call.trading_symbol,
                                expiry_date: call.expiry_date,
                                underlying_code: call.underlying_code,
                                strike: call.strike,
                                exchange: call.exchange,
                                underlying_symbol: call.underlying_symbol,
                                isCall: true,
                              })
                            }>
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 5 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M1 3.5C1.44253 4.10912 1.96128 4.6547 2.54255 5.12258C2.61557 5.18136 2.71776 5.18136 2.79078 5.12258C3.37205 4.6547 3.89081 4.10912 4.33333 3.5M1 1C1.44253 1.60912 1.96128 2.1547 2.54255 2.62258C2.61557 2.68136 2.71776 2.68136 2.79078 2.62258C3.37205 2.1547 3.89081 1.60912 4.33333 1"
                                stroke={theme === "dark" ? "white" : "#3F3F3F"}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Open Chart"
                            onClick={() => handleChartNavigation(call.code)}>
                            <svg role="img" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"
                             id="Tradingview--Streamline-Simple-Icons" height="12" width="12">
                              <path d="M7.9327 4.13945c0 0.67705 -0.5489 1.22595 -1.226 1.22595 -0.677 0 -1.22595 -0.5489 -1.22595 -1.226 0 -0.677 0.5489 -1.2259 1.226 -1.2259 0.67705 0 1.22595 0.54885 1.22595 1.22595zM4.875 3H0v2.4519h2.4231v3.6346H4.875Zm4.2981 0H12l-2.5529 6.0865h-2.8269z" 
                              fill={theme === "dark" ? "white" : "#3F3F3F"}
                              stroke-width="0.5"></path>
                            </svg>
                          </button>
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Add to Watchlist"
                            onClick={() => openAddToWatchlist(call)}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 1v10M1 6h10" stroke={theme === "dark" ? "white" : "#3F3F3F"} strokeWidth="1.2" strokeLinecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    ) : null}
                    {selectedData?.some((item) => item.code === call.code) && (
                      <div
                        className="sticky left-[30%] z-10"
                        style={{ minWidth: "0px" }}>
                        <div
                          className={`absolute right-0 top-[5px] px-2 bg-p400 py-0.5 border-2 rounded-sm font-medium flex gap-3 items-center z-20 ${
                            selectedData?.find(
                              (item) => item.code === call.code
                            )?.isBuy
                              ? "text-p150 border-p150"
                              : "text-red border-red"
                          }`}>
                          Added
                        </div>
                      </div>
                    )}

                    <>
                    {showRho && (
                        <div
                          className="p-2 w-32 border border-n100"
                          style={{
                            backgroundColor:
                              index == atmIndex
                                ? "rgba(18, 177, 110, 0.25)"
                                : getRowColor(call.strike, true),
                          }}>
                          {call["rho"]}
                        </div>
                      )}
                      {showVega && (
                        <div
                          className="p-2 w-32 border border-n100"
                          style={{
                            backgroundColor:
                              index == atmIndex
                                ? "rgba(18, 177, 110, 0.25)"
                                : getRowColor(call.strike, true),
                          }}>
                          {" "}
                          {call["vega"]}
                        </div>
                      )}
                      {showGamma && (
                        <div
                          className="p-2 w-32 border border-n100"
                          style={{
                            backgroundColor:
                              index == atmIndex
                                ? "rgba(18, 177, 110, 0.25)"
                                : getRowColor(call.strike, true),
                          }}>
                          {call["gamma"]}
                        </div>
                      )}
                      {showTheta && (
                        <div
                          className="p-2 w-32 border border-n100"
                          style={{
                            backgroundColor:
                              index == atmIndex
                                ? "rgba(18, 177, 110, 0.25)"
                                : getRowColor(call.strike, true),
                          }}>
                          {" "}
                          {call["theta"]}
                        </div>
                      )}
                      {showDelta && (
                        <div
                          className="p-2 w-32 border border-n100"
                          style={{
                            backgroundColor:
                              index == atmIndex
                                ? "rgba(18, 177, 110, 0.25)"
                                : getRowColor(call.strike, true),
                          }}>
                          {" "}
                          {call["delta"]}
                        </div>
                      )}

                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getRowColor(call.strike, true),
                        }}>
                        {" "}
                        {formatVolume(symbolData[call.code]?.volume)}
                      </div>

                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getRowColor(call.strike, true),
                        }}>
                        {getOIAnalysis(
                          symbolData[call.code]?.change_per,
                          symbolData[call.code]?.oi,
                          symbolData[call.code]?.previous_oi,
                          symbolData[call.code]?.ltp,
                          symbolData[call.code]?.prevClose
                        ) || '–'}
                      </div>

                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getRowColor(call.strike, true),
                          color:
                            parseFloat(symbolData[call.code]?.oi) -
                              parseFloat(symbolData[call.code]?.previous_oi) >=
                            0
                              ? "#5CA81D"
                              : "#DD6565",
                        }}>
                        {(() => {
                          const currentOI = parseFloat(
                            symbolData[call.code]?.oi
                          );
                          const prevOI = parseFloat(
                            symbolData[call.code]?.previous_oi
                          );

                          if (
                            !isFinite(currentOI) ||
                            !isFinite(prevOI) ||
                            prevOI === 0
                          )
                            return "–";

                          const change = ((currentOI - prevOI) / prevOI) * 100;
                          return change.toFixed(2) + "%";
                        })()}
                      </div>
                      <div
                        className="p-2 w-28 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getRowColor(call.strike, true),
                          position: "relative",
                          height: "fixed",
                          textAlign: "left",
                        }}>
                        <div style={{ position: "relative", zIndex: "2" }}>
                          {formatVolume(symbolData[call.code]?.oi)}
                        </div>
                        <div
                          className="bg-red"
                          style={{
                            position: "absolute",
                            bottom: "50%",
                            right: 0,
                            width: `${
                              (symbolData[call.code]?.oi / maxVolume) * 100
                            }%`,
                            height: "10px",
                            zIndex: 0,
                            borderBottomLeftRadius: 3,
                            borderTopLeftRadius: 3,
                            opacity: 0.19,
                          }}
                        />
                      </div>
                      <div
                        className="p-2 w-44 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getRowColor(call.strike, true),
                        }}>
                        <span
                          style={{
                            color:
                              symbolData[call.code]?.change_per > 0
                                ? "#5CA81D"
                                : "#DD6565",
                          }}>
                          ({symbolData[call.code]?.change_per}%)
                        </span>{" "}
                        {symbolData[call.code]?.ltp}
                      </div>
                    </>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div
            className="shrink-0 overflow-y-scroll overflow-x-hidden no-scrollbar bg-p400 text-[12px] text-p300 text-center"
            ref={centerRef}
            onScroll={() => syncVerticalScroll(centerRef)}>
            <div>
              {calls.map((call, index) => (
                <div key={index} className="flex">
                  <div
                    className="p-2 w-32 border text-center border-n100"
                    style={{
                      backgroundColor:
                        index == atmIndex
                          ? "rgba(18, 177, 110, 0.25)"
                          : "transparent",
                    }}>
                    {call.strike}
                  </div>
                  <div
                    className="p-2 w-32 border text-center border-n100"
                    style={{
                      backgroundColor:
                        index == atmIndex
                          ? "rgba(18, 177, 110, 0.25)"
                          : "transparent",
                    }}>
                    {" "}
                    {call.iv && !isNaN(parseFloat(call.iv))
                      ? parseFloat(call.iv).toFixed(2)
                      : "-"}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {showPuts && (
            <div
              className="h-scrollbar-only text-[12px] text-p300 text-center bg-p400 flex-1 min-w-0"
              ref={putBodyRef}
              onScroll={() => {
                syncVerticalScroll(putBodyRef);
                syncHorizontalScroll(putBodyRef, "putBody");
              }}>
              <div className="min-w-max w-full expanded-table-cols">
                {puts.map((put, index) => (
                  <div
                    key={index}
                    ref={index === atmIndex ? targetRowRef : null}
                    className="flex relative"
                    onMouseEnter={() => handleRowMouseEnter(index)}
                    onMouseLeave={handleRowMouseLeave}>
                    {!selectedData?.some(
                      (item) => item.code === puts[index].code
                    ) &&
                    selectedRowIndex === index &&
                    divVisibility ? (
                      <div
                        className="sticky left-[45%] z-10 bg-transparent"
                        style={{ minWidth: "0px" }}>
                        <div className="absolute left-0 top-1 flex gap-1 items-center px-2 z-20">
                          <button
                            className={`p-2 py-0.5 rounded-sm text-white font-medium bg-p150 ${putsDataCon[index]?.buyBtnState ? "active" : ""}`}
                            onClick={() => {
                              if (isScalpOrderChecked && scalpLots) {
                                handleBuyClick("puts", index, scalpLots);
                              } else if (directAddToBasket) {
                                handleDirectAddToBasket(puts[index], true, false);
                              } else {
                                handleAddModal(puts[index], index, true, false);
                              }
                            }}>
                            B
                          </button>
                          <button
                            className={`p-2 py-0.5 rounded-sm text-white font-medium bg-red ${putsDataCon[index]?.sellBtnState ? "active" : ""}`}
                            onClick={() => {
                              if (isScalpOrderChecked && scalpLots) {
                                handleSellClick("puts", index, scalpLots);
                              } else if (directAddToBasket) {
                                handleDirectAddToBasket(puts[index], false, false);
                              } else {
                                handleAddModal(puts[index], index, false, false);
                              }
                            }}>
                            S
                          </button>

                          {/* Chart navigation icon */}
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Market Depth"
                            onClick={() =>
                              openMarketDepth({
                                code: puts[index].code,
                                instrumentName: puts[index].instrument_name,
                                trading_symbol: puts[index].trading_symbol,
                                expiry_date: puts[index].expiry_date,
                                underlying_code: puts[index].underlying_code,
                                strike: puts[index].strike,
                                exchange: puts[index].exchange,
                                underlying_symbol:
                                  puts[index].underlying_symbol,
                                isCall: false,
                              })
                            }>
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 5 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M1 3.5C1.44253 4.10912 1.96128 4.6547 2.54255 5.12258C2.61557 5.18136 2.71776 5.18136 2.79078 5.12258C3.37205 4.6547 3.89081 4.10912 4.33333 3.5M1 1C1.44253 1.60912 1.96128 2.1547 2.54255 2.62258C2.61557 2.68136 2.71776 2.68136 2.79078 2.62258C3.37205 2.1547 3.89081 1.60912 4.33333 1"
                                stroke={theme === "dark" ? "white" : "#3F3F3F"}
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Open Chart"
                            onClick={() => handleChartNavigation(puts[index].code)}>
                            <svg role="img" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"
                             id="Tradingview--Streamline-Simple-Icons" height="12" width="12">
                              <path d="M7.9327 4.13945c0 0.67705 -0.5489 1.22595 -1.226 1.22595 -0.677 0 -1.22595 -0.5489 -1.22595 -1.226 0 -0.677 0.5489 -1.2259 1.226 -1.2259 0.67705 0 1.22595 0.54885 1.22595 1.22595zM4.875 3H0v2.4519h2.4231v3.6346H4.875Zm4.2981 0H12l-2.5529 6.0865h-2.8269z" 
                              fill={theme === "dark" ? "white" : "#3F3F3F"}
                              stroke-width="0.5"></path>
                            </svg>
                          </button>
                          <button
                            className="p-1 rounded-sm bg-p400 text-p300 border border-n200"
                            title="Add to Watchlist"
                            onClick={() => openAddToWatchlist(puts[index])}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 1v10M1 6h10" stroke={theme === "dark" ? "white" : "#3F3F3F"} strokeWidth="1.2" strokeLinecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    ) : null}
                    {selectedData?.some(
                      (item) => item.code === puts[index].code
                    ) && (
                      <div
                        className="sticky left-[69%] z-10"
                        style={{ minWidth: "0px" }}>
                        <div
                          className={`absolute left-0 top-[5px] px-2 bg-p400 py-0.5 border-2 rounded-sm font-medium flex gap-3 items-center z-20 ${
                            selectedData?.find(
                              (item) => item.code === puts[index].code
                            )?.isBuy
                              ? "text-p150 border-p150"
                              : "text-red border-red"
                          }`}>
                          Added
                        </div>
                      </div>
                    )}
                    <div
                      className="p-2 w-44 border border-n100"
                      style={{
                        backgroundColor:
                          index == atmIndex
                            ? "rgba(18, 177, 110, 0.25)"
                            : getPutRowColor(puts[index].strike),
                      }}>
                      {symbolData[puts[index].code]?.ltp}{" "}
                      <span
                        style={{
                          color:
                            symbolData[puts[index].code]?.change_per > 0
                              ? "#5CA81D"
                              : "#DD6565",
                        }}>
                        ({symbolData[puts[index].code]?.change_per}%)
                      </span>
                    </div>
                    <div
                      className="p-2 w-28 border border-n100"
                      style={{
                        backgroundColor:
                          index == atmIndex
                            ? "rgba(18, 177, 110, 0.25)"
                            : getPutRowColor(puts[index].strike),
                        position: "relative",
                        height: "fixed",
                        textAlign: "right",
                      }}>
                      <div style={{ position: "relative", zIndex: "2" }}>
                        {formatVolume(symbolData[puts[index].code]?.oi)}
                      </div>

                      {/* Progress bar */}
                      <div
                        style={{
                          position: "absolute",
                          bottom: "50%",
                          left: 0,
                          width: `${Math.min((symbolData[puts[index].code]?.oi / maxPutVolume) * 100, 100)}%`,
                          height: "10px", // Adjust height as needed
                          backgroundColor: "#19C37D",
                          zIndex: 0,
                          borderBottomRightRadius: 3,
                          borderTopRightRadius: 3,
                          opacity: 0.19,
                        }}
                      />
                    </div>
                    <div
                      className="p-2 w-32 border border-n100"
                      style={{
                        backgroundColor:
                          index == atmIndex
                            ? "rgba(18, 177, 110, 0.25)"
                            : getPutRowColor(puts[index].strike),
                        color:
                          parseFloat(symbolData[puts[index].code]?.oi) -
                            parseFloat(
                              symbolData[puts[index].code]?.previous_oi
                            ) >=
                          0
                            ? "#5CA81D"
                            : "#DD6565",
                      }}>
                      {" "}
                      {(() => {
                        const currentOI = parseFloat(
                          symbolData[puts[index]?.code]?.oi
                        );
                        const prevOI = parseFloat(
                          symbolData[puts[index].code]?.previous_oi
                        );

                        if (
                          !isFinite(currentOI) ||
                          !isFinite(prevOI) ||
                          prevOI === 0
                        )
                          return "–";

                        const change = ((currentOI - prevOI) / prevOI) * 100;
                        return change.toFixed(2) + "%";
                      })()}
                    </div>
                    <div
                      className="p-2 w-32 border border-n100"
                      style={{
                        backgroundColor:
                          index == atmIndex
                            ? "rgba(18, 177, 110, 0.25)"
                            : getPutRowColor(puts[index].strike),
                      }}>
                      {getOIAnalysis(
                        symbolData[puts[index].code]?.change_per,
                        symbolData[puts[index].code]?.oi,
                        symbolData[puts[index].code]?.previous_oi,
                        symbolData[puts[index].code]?.ltp,
                        symbolData[puts[index].code]?.prevClose
                      ) || '–'}
                    </div>
                    <div
                      className="p-2 w-32 border border-n100"
                      style={{
                        backgroundColor:
                          index == atmIndex
                            ? "rgba(18, 177, 110, 0.25)"
                            : getPutRowColor(puts[index].strike),
                      }}>
                      {formatVolume(symbolData[puts[index].code]?.volume)}
                    </div>
                    {showDelta && (
                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getPutRowColor(puts[index].strike),
                        }}>
                        {" "}
                        {puts[index]["delta"]}
                      </div>
                    )}
                    {showTheta && (
                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getPutRowColor(puts[index].strike),
                        }}>
                        {puts[index]["theta"]}
                      </div>
                    )}
                    {showGamma && (
                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getPutRowColor(puts[index].strike),
                        }}>
                        {puts[index]["gamma"]}
                      </div>
                    )}
                    {showVega && (
                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getPutRowColor(puts[index].strike),
                        }}>
                        {puts[index]["vega"]}
                      </div>
                    )}
                    {showRho && (
                      <div
                        className="p-2 w-32 border border-n100"
                        style={{
                          backgroundColor:
                            index == atmIndex
                              ? "rgba(18, 177, 110, 0.25)"
                              : getPutRowColor(puts[index].strike),
                        }}>
                          {puts[index]["rho"]}
                        </div>
                      )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>  
  );
};

export default OptionChainTable;
